module.exports = __webpack_public_path__ + "img/JoeNelson.f9510ef8.jpg";